export default {
      id: "status_flag_yellow-usage",
      viewBox: "0 0 20 20",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#status_flag_yellow",
      toString: function () {
        return this.url;
      }
    }